<template>
    <Tooltip arrowColor="bg-white" arrowBorderColor="border-border">
        <template #trigger>
            <slot />
        </template>
        <template #content>
            <div class="max-w-xl">
                <ModelPreview
                    :imageSrc="imageSrc"
                    :modelClass="modelClass"
                    :modelName="modelName"
                    componentPadding="pr-3"
                    :typeId="typeId"
                    :fileUrl="fileUrl"
                />
            </div>
        </template>
    </Tooltip>
</template>

<script>
import Tooltip from '@/Components/Elements/Tooltip.vue'
import ModelPreview from '@/Components/ModelComponents/ModelPreview.vue'
export default {
    components: {
        Tooltip,
        ModelPreview,
    },

    props: {
        imageSrc: {
            type: String,
        },
        modelClass: {
            type: String,
            required: true,
        },
        modelName: {
            type: String,
            required: true,
        },
        typeId: {
            type: [String, null],
            default: null,
        },
        fileUrl: {
            type: String,
            default: null,
        },
    },
}
</script>
